import { apiConfig } from 'web-common';
import { request } from "../../../util/request";

// 获取证件类型列表
export const getCertificateTypeList = () => {
  return request( '/corruption/certificateTypes', {}, { method: 'GET', baseURL: apiConfig.GLOBAL_WEBSITE_URL });
}

// 查询贪腐信息
export const getCorruptionList = (params: {
    certificateType: string,
    certificateCode: string,
    userName: string
}) => {
  return request( '/corruption/check', params, { method: 'GET', baseURL: apiConfig.GLOBAL_WEBSITE_URL });
}